import { render, staticRenderFns } from "./HardwareSection.vue?vue&type=template&id=059db942&"
import script from "./HardwareSection.vue?vue&type=script&lang=js&"
export * from "./HardwareSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports